module.exports = __webpack_public_path__ + "img/CZ45317054.f3812744.svg";